var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFree15Days(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 220 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 80,
    width: 120,
    height: 80,
    rx: 12,
    fill: "#E9F8EC",
    stroke: "#2E9F3E",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 60,
    width: 130,
    height: 30,
    rx: 10,
    fill: "#FFF3E6",
    stroke: "#F2994A",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 60,
    width: 10,
    height: 100,
    rx: 5,
    fill: "#2E9F3E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 95,
    width: 120,
    height: 10,
    rx: 5,
    fill: "#F2994A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110 55             C95 40, 65 45, 80 70             C95 60, 105 65, 110 55Z",
    fill: "#2E9F3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110 55             C125 40, 155 45, 140 70             C125 60, 115 65, 110 55Z",
    fill: "#F2994A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 50 L40 60 M35 55 L45 55",
    stroke: "#2E9F3E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180 70 L180 78 M176 74 L184 74",
    stroke: "#F2994A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFree15Days);
export default __webpack_public_path__ + "static/media/free_15_days.1421c8161444e1740b3ec3743d2c4c9d.svg";
export { ForwardRef as ReactComponent };